import React, { useState } from "react";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { Box, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import SingleChart from "../../shared/charts/SingleChart";
import ZoomOutMapIcon from '@mui/icons-material/ZoomOutMap';
import Checkbox from "@material-ui/core/Checkbox";
import StopSharpIcon from "@material-ui/icons/StopSharp";
import { LOADING } from "../../action";
import { postRequest } from "../../services/ApiServices";
import moment from 'moment';
import Button from '@mui/material/Button';
import { useDispatch } from "react-redux";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import CancelIcon from '@mui/icons-material/Cancel';
import { values,months } from "./ChartConstants";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import * as  FileSaver from 'file-saver';
import XLSX from 'sheetjs-style';

const useStyles = makeStyles((theme) => ({
    heading: {
        color: "#ff4717",
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: "center",
        color: theme.palette.text.secondary,

    },  
    theadingstyles: {
        background: "rgb(26 26 49)",
        padding: "12px",
        borderTopRightRadius: "10px",
        borderTopLeftRadius: "10px",
        color: "white",
        fontSize: "16px",
    },
}));

export default function Chart(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const {chartParameters,transformerListequip,formObj,transformerId} = props;
    const title = chartParameters.title;
    const testParameter = chartParameters.field
    const [chartData, setChartData] = React.useState([]);
    const [chartResData, setChartResData] = React.useState([]);
    const [chartTestParameter, setChartTestParameter] =React.useState([]);
    const [open, setOpen] = React.useState(false);
    const [fullWidth, setFullWidth] = React.useState(true);
    const [showchart, setShowChart] = React.useState([]);
    const [allTheCheckBoxKeysForChecked, setAllTheCheckBoxKeysForChecked]=useState(values)
  React.useEffect(() => {
    if(!transformerListequip.length)
    {
    clearChart()
    }
    if(chartTestParameter.length)
    {
        getChartData(chartTestParameter)
    }
},[transformerListequip])

const exportToExcel = async (excelDate, fileName) => {
    excelDate.forEach((d) => {
        let result = d.name.split("-");
        d.Name = result[0] + " ( " + d.imoNumber + " ) ";;
        d.EquipmentName = result[1];
        d.TestParameter = d.testParameter;

        if (d.dataEntryDt) {
          d.ReportDate = moment(d.dataEntryDt).format('DD-MM-YYYY');
        }

        d.TestCount = d.testCountcss;
        d.SampleControlNo = d.sampleControlNoCd
        delete d.name
        delete d.imoNumber
        delete d.testParameter
        delete d.testCountcss
        delete d.sampleControlNoCd
        delete d.pdfFileName
        delete d.dataEntryDt
    })
    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const ws = XLSX.utils.json_to_sheet(excelDate);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
}

const handleClickFileDownload = (chartType) => {
    exportToExcel(chartResData, title)
};

const handleClickOpen = (chartType) => {       
    setShowChart(chartData);
    setOpen(true);
};

const handleClose = () => {
    setOpen(false);
};

const selectedTestParameter = (event) => {
    let checkedList = chartTestParameter;
    var isChecked = event.target.checked;
    
    if (isChecked) {
        checkedList.push(event.target.name);
        console.log("checked", checkedList);
    } else {
        let testparametersIndex = checkedList.indexOf(event.target.name);
        checkedList.splice(testparametersIndex, 1);
    }
    setChartTestParameter(checkedList);

    if (checkedList.length) {
        getChartData( checkedList);

    } else {
        setChartData([]);
    }
};
const  getChartData = (chatType) => {
    //debugger
    //;
    dispatch({ type: LOADING, payload: true });
    let filterValidObj = {};
    var tarKeys = []; 
    transformerListequip.forEach((obj) => { tarKeys.push(obj.shipId) });
    filterValidObj = { ...filterValidObj, vesselKey: tarKeys.join() }
    filterValidObj = { ...filterValidObj, testParameter: chatType.join()}
    filterValidObj = { ...filterValidObj, equipmentKey: transformerId.join() }
    const url =
    process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Trend/Vessels/Filter`;
   
    postRequest(url, filterValidObj)
    .then((res) => {
        //debugger
        let data=[];
        res.data.forEach((d) => {
            d.dataEntryDt = moment(d.dataEntryDt).format('YYYY/MM/DD');
            if (d.dataEntryDt > formObj.bunkeredFromDate && d.dataEntryDt < formObj.bunkeredToDate){
                data.push(d)
            }
        })
        res.data=data;
        let result = getData(res.data);
            if (result.length) {
                setChartData(result);
                setChartResData(res.data);
            } else {
                setChartData([]);
            }
        dispatch({ type: LOADING, payload: false });
    })
    .catch((error) => {
        dispatch({ type: LOADING, payload: false });
    });

  };

  function getData(x) {
    //console.log("Chart Data:",x);
    var transformersName = [];
    x.forEach((rec) => {
      transformersName.push(rec.name);
    });
    transformersName = [...new Set(transformersName)];
    var testParms = [];
    x.forEach((rec) => {
      testParms.push(rec.testParameter);
    });
    testParms = [...new Set(testParms)];
    var uDate = [];
    x.forEach((rec) => {
      //let dateFormat = new Date(rec.dataEntryDt).getDate() + '-' + mon[new Date(rec.dataEntryDt).getMonth()] + '-'+ new Date(rec.dataEntryDt).getFullYear();
      ///uDate.push(dateFormat);
      uDate.push(new Date(rec.dataEntryDt));
    });
    //console.log(uDate);
    //uDate = [...new Set(uDate)];
    uDate = [...new Map(uDate.map(item => [JSON.stringify(item), item])).values()];
    uDate.sort((a, b,) => a.valueOf() - b.valueOf());
    //console.log(uDate);
    var xAxis = [];
    xAxis.push("X");
    transformersName.forEach((tn) => {
      testParms.forEach((tp) => {
        let itemName = tn + ' - ' + tp;
        if (typeof tp != "undefined") {
          xAxis.push({ label: itemName, type: 'number' });
          xAxis.push({ role: "tooltip", type: "string", p: { html: true } });
        }
      });
    });

    //xAxis.push("SampleNumber");
    var yAxis = [];

    for (var v = 0; v < uDate.length; v++) {
      var yr = [];
      yr.push(uDate[v]);
      for (var k = 0; k < transformersName.length; k++) {
        for (var u = 0; u < testParms.length; u++) {
          yr.push(null);
          yr.push(null);
        }
      }
      yAxis.push(yr);
    }
    for (var i = 0; i < yAxis.length; i++) {
      let row = yAxis[i];
      for (var w = 0; w < x.length; w++) {
        var rec = x[w];
        // var mont = mon[new Date(rec.dataEntryDt).getMonth()];
        let mont = new Date(rec.dataEntryDt).getDate() + '-' + months[new Date(rec.dataEntryDt).getMonth()] + '-' + new Date(rec.dataEntryDt).getFullYear();
        // var testp = rec.testParameter;
        let itemName = rec.name + ' - ' + rec.testParameter;
        let indexPara = xAxis.findIndex(obj => obj.label == itemName);
        //if (row[0] == mont) {
        if (row[0].getTime() === new Date(rec.dataEntryDt).getTime()) {
          yAxis[i][indexPara] = rec.testCountcss;
          let tooltip = "";
          tooltip += "Asset: " + itemName + "<br>";
          tooltip += "Value: " + rec.testCountcss + "<br>";
          tooltip += "Date: " + mont + "<br>";
          tooltip += "Sample No: " + rec.sampleControlNoCd;
          yAxis[i][indexPara + 1] = tooltip;
          //yAxis[i][3]=rec.sampleControlNoCd;
        }

      }
    }
    //console.log(xAxis);
    //console.log(yAxis);
    // if(xAxis.length > 1){
    // return [xAxis, ...yAxis];setSelectedVesselKey
    // } else {
    //   return [];
    // }

    return [xAxis, ...yAxis];
  }
  const clearChart = () =>{
    //debugger
    setAllTheCheckBoxKeysForChecked(values);
    setChartData([])
    setChartResData([])
    setChartTestParameter([]);
}    
return (
    <Grid item xs={12} md={6} className="trendschart">
        <Dialog
            fullWidth={fullWidth}
            maxWidth="xl"
            fullScreen={true}
            open={open}
            onClose={handleClose}
        >
            <DialogActions>
                <Button onClick={handleClose}><CancelIcon /></Button>
            </DialogActions>

            <DialogContent>
                <SingleChart chartData={showchart} />
            </DialogContent>

        </Dialog>

        <Typography
            variant="h5"
            align="left"
            className={clsx(classes.heading, classes.theadingstyles)}
        >
            <div>
                {title}

                {chartData.length > 1 ? (
                    <button style={{ float: "right", padding: "0px" }} onClick={() => handleClickFileDownload()}>
                        <FileDownloadIcon />
                    </button>
                ) : ""}

                {chartData.length > 1 ? (
                    <button style={{ float: "right", padding: "0px" }} onClick={() => handleClickOpen()}>
                        <ZoomOutMapIcon />
                    </button>
                ) : ""}
            </div>
        </Typography>

        <Paper
            className={classes.paper + " scrollBar"}
            style={{ height: "400px", overflow: "auto" }}
        >
            <Grid container spacing={2} style={{ textAlign: "left" }} >
                {testParameter.map((item)=>{
                    return(
                        <Grid item >
                            <Box component="">
                                <Checkbox
                                    name={item}
                                    value={item}
                                    label={item}
                                    onClick={(event) => {
                                        setAllTheCheckBoxKeysForChecked({ ...allTheCheckBoxKeysForChecked, [item]: event.target.checked });
                                        selectedTestParameter(event);
                                    }}
                                    checked={allTheCheckBoxKeysForChecked[item]}
                                    className={clsx(classes.MuiButtonBaseRoot)}
                                    checkedIcon={
                                        <StopSharpIcon
                                            className={clsx(classes.MuiSvgIconRoot)}
                                        />
                                    }
                                    inputProps={{ "aria-label": "Checkbox A" }}
                                />
                                <Box component="span" pl={1}>
                                    {item}
                                </Box>
                            </Box>
                        </Grid>
                    )
                })}    
            </Grid>
            
                {chartData.length > 1 ? (
                <div>
                    <SingleChart chartData={chartData} />
                </div>
                ) : (
                    chartData.length == 1 ? (
                        <Box py={4} fontWeight="bold" >No Records found</Box>
                    ) : (
                        <React.Fragment>
                            {transformerListequip.length == 0 ? (
                                <Box py={4} fontWeight="bold" >Please select Ship key</Box>
                            ) :  transformerListequip.length > 0 ? (<Box py={4} fontWeight="bold" >Please select test parameters</Box>)
                                : (<Box py={4} fontWeight="bold" ></Box>)}
                        </React.Fragment>
                    )
                )
            }
              </Paper>
            
            </Grid>

            
);
}